<template>
    <form @submit.prevent="editDeliveryType">
        <div>
            <label class="block mb-1" for="name">{{ $t('labels.name') }}</label>
            <InputText
                v-model="deliveryType.name"
                name="name"
                type="text"
                placeholder="name in Japanese"
                class="w-full"
                />      
                <p v-if="errors.name" class="text-sm text-danger">{{ errors.name[0] }}</p>          
        </div>
        <div class="mt-4">
            <label class="block mb-1" for="name_jpn">{{ $t('labels.name_jp') }}</label>
            <InputText
                v-model="deliveryType.name_jpn"
                name="name_jpn"
                type="text"
                placeholder="(Optional)"
                class="w-full"
                />      
                <p v-if="errors.name_jpn" class="text-sm text-danger">{{ errors.name_jpn[0] }}</p>          
        </div>
        <div class="mt-4">
            <label class="block mb-1" for="yamato_id">Yamato Id</label>
            <InputText
                v-model="deliveryType.yamato_id"
                name="yamato_id"
                type="text"
                placeholder="(Optional)"
                class="w-full"
                />      
                <p v-if="errors.yamato_id" class="text-sm text-danger">{{ errors.yamato_id[0] }}</p>          
        </div>
        <div class="flex justify-end mt-6">
            <button :disabled="loading" class="px-6 py-2 text-white rounded outline-none bg-secondary ring-0">
                <span v-if="loading">Loading</span>
                <span v-else>{{ $t('actions.update') }}</span>
            </button>
        </div>
    </form>
</template>

<script setup>
import { ref , defineEmits , defineProps, onMounted } from 'vue';
import ApiService from '@/services/ApiService';
import { toast } from 'vue3-toastify';

//prime vue components
import InputText from 'primevue/inputtext';

const props = defineProps({
    id : Number
})
const emit = defineEmits(['edited']);

const deliveryType = ref({
    name : '',
    name_jpn : '',
    yamato_id : ''
})
const errors = ref({});
const loading = ref(false);

const editDeliveryType = () => {
    loading.value = true;
    const id = toast.loading('Updating, please wait . . .');
    ApiService.put(`delivery-types/${props.id}` , deliveryType.value).then(() => {
        loading.value = false;
        toast.update(id, {
            render: "Updated delivery type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'success',
            isLoading: false,
        });
        emit('edited');
    }).catch((res) => {
        loading.value = false;
        toast.update(id, {
            render: "Error updating delivery type.",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: 'error',
            isLoading: false,
        });
        errors.value = res?.response?.data && res?.response?.data?.errors ? res?.response?.data?.errors : {};
    })
}

onMounted(() => {
    ApiService.get(`delivery-types/${props.id}`).then((res) => {
        deliveryType.value = res.data
    }).catch(() => {
        toast.error("Error fetching data.");
    })
})
</script>

<style scoped>

</style>